import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '@/views/LandingPage.vue'
import LiveTraining from '@/components/LiveTraining/LiveTraining.vue'
import VirtualTraining from '@/components/VirtualTraining/VirtualTraining.vue'
import Shop from '@/components/Shop/Shop.vue'
import TacticalGames from '@/components/TacticalGames/TacticalGames.vue'
import AboutUs from '@/components/AboutUs/AboutUs.vue'
import Contact from '@/components/Contact.vue'
import CourseDetail from '@/components/LiveTraining/CourseDetail.vue'

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: LandingPage
  },
  {
    path: '/live-training',
    name: 'LiveTraining',
    // Lazy Loading: El componente se carga solo cuando se necesita
    component: LiveTraining
  },
  {
    path: '/virtual-training',
    name: 'VirtualTraining',
    component: VirtualTraining
  },
  {
    path: '/shop',
    name: 'Shop',
    component: Shop
  },
  {
    path: '/tactical-games',
    name: 'TacticalGames',
    component: TacticalGames
  },
  {
    path: '/about-us',
    name: 'AboutUs',
    component: AboutUs
  },
  {
    path: '/contact',
    name: 'ContactUs',
    component: Contact
  },
  {
    // Los dos puntos :id significan que es dinámico (ej: /training/1)
    path: '/live-training/:id', 
    name: 'CourseDetail',
    component: CourseDetail,
    props: true // Permite pasar el ID como prop
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Esto asegura que al cambiar de ruta, la página empiece desde arriba
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  next(); 
});

export default router